export default "__VITE_ASSET__CpXa0Tjm__"